'use strict';

module.exports = {
    SIGN: 'MASUK',
    SIGN_JOIN: 'Masuk atau gabung gratis!',
    EMAIL_EXISTS: 'Email ini sudah digunakan.',
    INVALID_EMAIL: 'Silahkan masukkan alamat Email yang valid',
    INVALID_FIRST_NAME: 'Silahkan masukkan Nama depan yang valid',
    INVALID_LAST_NAME: 'Silahkan masukkan Nama belakang yang valid',
    INVALID_PASSWORD: 'Silahkan masukkan 6-20 karakter (A-Z, a-z, 0-9 only)',
    INVALID_REPASSWORD: 'Password nya tidak sama',
    INVALID_VALID_CODE: 'Masukkan kode yang valid',
    UNAVIALABLE_SERVICE: 'Servis ini tidak tersedia sekarang, silahkan coba lagi.',
    EMPTY_VALID_CODE: 'Masukkan karakter yang anda lihat di gambar',
    NOT_MEMBER: 'Masih bukan member?',
    ALREADY_MEMBER: 'Sudah punya akun AliExpress/Alibaba?',
    EMAIL: 'Alamat email',
    CONTACT_NAME: 'Nama kontak:',
    FIRST_NAME: 'Nama Depan',
    LAST_NAME: 'Nama Belakang',
    PASSWORD: 'Kata sandi',
    REPASSWORD: 'Masukkan lagi password:',
    EMPTY_CODE: 'Masukkan kode yang tertera:',
    REFRESH: 'Menyegarkan',
    CREATE_MY_ACCOUNT: 'MEMBUAT AKUN',
    NAME: 'Nama',
    VERIFICATION: 'Kode verifikasi',
    AGREE_MENT: 'Dengan membuat akun, Anda setuju dengan',
    AE_MEMBER_SHIP: 'AliExpress.com Perjanjian Keanggotaan Gratis',
    AND: 'dan',
    PRIVACY_POLICY: 'Kebijakan Privasi',
    SLIDE_SUBMIT: 'Geser ke kanan untuk memverifikasi',
    SLIDE_SUBMIT_TIPS: 'Keberhasilan',
    LOADING: 'Pemuatan…',
    SLIDE_SUBMIT_ERROR_TIPS: 'Geser ke kanan untuk memverifikasi',
    SHOP_NOW: 'BELANJA SEKARANG',
    SIGN_IN: 'Log in',
    REGISTER_SMS: 'Daftar dengan SMS',
    REGISTER_EMAIL: 'Daftar dengan Email',
    PHONE_NUMBER: 'Nomor telepon',
    VALID_NUMBER: 'Masukkan nomor telepon yang valid.',
    SEND_SMS_CODE: 'SKirim kode SMS',
    SMS_POLICY: 'Kami akan mengirimkan kode verifikasi melalui SMS ke nomor telepon yang Anda masukkan. Pastikan kode negara dan nomor telepon sudah benar.',
    SEND_TO: 'Kami telah mengirimkan kode ke',
    VERIFICATION_RECEIVED: 'Masukkan kode verifikasi yang Anda terima atau',
    EDIT_NUMBER: 'edit nomor.',
    RESEND_CODE: 'Kirim ulang kode',
    LAST_STEP: 'Langkah Terakhir',
    SET_SIGN_IN_PASSWORD: 'Atur kata sandi Masuk untuk membuat akun Anda lebih aman.',
    INVALID_PHONE_PASSWORD: '6-20 karakter (hanya huruf dan angka)',
    NOT_CORRECT_CODE: 'Kode salah, coba lagi.',
    SAVE_PASSWORD: 'Simpan kata sandi',
    NO_RECEIVED_CODE: 'Jika Anda masih belum menerima kode, cobalah untuk',
    VIA_EMAIL: 'Daftar melalui Email'
};